import lottie from "lottie-web";

const lottieInit = () => {
  const cards = document.querySelectorAll(".project__card");
  const lottieProjectFiles = [
    "../../json/01_v02.json",
    "../../json/02_v01.json",
    "../../json/03_v02.json",
    "../../json/04_v01.json",
    "../../json/05_v01.json",
    "../../json/06_v01.json",
    "../../json/07_v01.json",
    "../../json/08_v02.json",
    "../../json/09_v01.json",
    "../../json/10_v01.json",
    "../../json/11_v02.json",
  ];

  // Load Lottie animations for project cards
  cards.forEach((card, index) => {
    const lottieContainer = card.querySelector(".lottie-container");
    if (lottieContainer) {
      const animation = lottie.loadAnimation({
        container: lottieContainer,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: lottieProjectFiles[index],
      });

      animation.setSpeed(0.8);
    }
  });

  const globeContainer = document.querySelector(".hero__globe");
  if (globeContainer) {
    const globeAnimation = lottie.loadAnimation({
      container: globeContainer,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "../../json/14_v02.json",
    });

    globeAnimation.setSpeed(0.8);
  }

  const inspirationContainer = document.querySelector(".inspiration__img");
  if (inspirationContainer) {
    const inspirationAnimation = lottie.loadAnimation({
      container: inspirationContainer,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "../../json/13_v01.json",
    });

    inspirationAnimation.setSpeed(0.8);
  }

  const opportunitiesContainer = document.querySelector(".opportunities__img");
  if (opportunitiesContainer) {
    const opportunitiesAnimation = lottie.loadAnimation({
      container: opportunitiesContainer,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "../../json/12_v01.json",
    });

    opportunitiesAnimation.setSpeed(0.5);
  }
  
  const helpContainer = document.querySelector(".help__img");
  if (helpContainer) {
    const helpAnimation = lottie.loadAnimation({
      container: helpContainer,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "../../json/09_v01.json",
    });

    helpAnimation.setSpeed(0.5);
  }
};

export default lottieInit;
